<div
  class="container"
  [id]="$safeNavigationMigration(chapter?.title)"
  [ngStyle]="{ background: $safeNavigationMigration(chapter?.background) }"
  [class.contrast]="chapter?.contrast">
  @if (chapter?.icon || chapter?.title) {
    <div class="head max-width">
      <customer-app-equity-chapter-icon
        [chapter]="chapter"
        [contrast]="$safeNavigationMigration(chapter?.contrast)"></customer-app-equity-chapter-icon>
      <p class="bold">{{ chapter?.title }}</p>
      <div style="flex: 1"></div>
      @if (showPrint() && equityPageDataService.canSwitchCountry) {
        <div class="mode-switcher">
          <p
            class="bold"
            style="margin-left: 10px">
            {{ 'equity.germany' | translate }}
          </p>
          <mat-slide-toggle
            labelPosition="before"
            color="primary"
            [(ngModel)]="isRow"
            (change)="toggleROW()"></mat-slide-toggle>
          <p
            class="bold"
            style="margin-left: 10px">
            {{ 'equity.ROW' | translate }}
          </p>
        </div>
      }
      @if (showPrint()) {
        <coin-v2-button
          type="secondary"
          icon="chevron_right"
          iconPos="right"
          [text]="'general.print' | translate"
          (click)="print()"></coin-v2-button>
      }
    </div>
  }
  <div
    class="content"
    [class.full-width]="chapter?.options?.fullWidth">
    <ng-template appEquityPageData></ng-template>
  </div>
</div>
